export default __webpack_public_path__ + "static/media/coins.3ca6e485.png";